export default "__VITE_ASSET__1eb7ff1c__"